import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  Renderer2,
  Self
} from "@angular/core";
import {FormControlName} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {InputRootController} from "./root/input-root.controller";
import {InputTypes} from "./input.types";
import {LoadingState} from "./state/loading-state.service";
import {InputType} from "./root/input-type"

let NEXT_ID = 0;
@Directive({
  selector: "input[valgInput], textarea[valgInput]",
  providers: [{ provide: InputType, useExisting: InputDirective }]
})
export class InputDirective extends InputRootController implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  
  public id = `valg-input-${NEXT_ID++}`;

  @Input() errorKey: string | undefined;
  @Input() hideControls = false;

  @Output() focusOut = new EventEmitter<Event>();
  @Output() keyUp = new EventEmitter<string>();

  @HostBinding("attr.type") @Input() public type: InputTypes = "text";
  
  constructor(
    @Optional() @Self() @Inject(FormControlName) protected override formControl: FormControlName,
    protected override cdr: ChangeDetectorRef,
    protected override elementRef: ElementRef<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    protected override renderer: Renderer2,
    protected override translate: TranslateService,
    protected override loadingState: LoadingState
  ) {
    super(formControl, cdr, elementRef, renderer, translate, loadingState);
    this.renderer.addClass(this.elementRef.nativeElement, 'valg-input')

    this.setAttribute({name: 'autocomplete', value:'off'});
  }

  public ngOnInit(): void {
    if ((this.elementRef.nativeElement.type === "number" || this.elementRef.nativeElement.tagName === 'TEXTAREA') && this.hideControls) {
      this.renderer.addClass(this.elementRef.nativeElement, "valg-input--hide-controls");
    }
    if(this.elementRef.nativeElement.id === ""){
      this.setId(this.id);
    } else{
      this.id = this.elementRef.nativeElement.id;
    }
  }

  @HostListener('focusout', [ '$event' ])
  onFocusOut($event: Event | undefined) {
    this.focusOut.emit($event);
  }

  @HostListener('keyup')
  onKeyUp() {
    this.keyUp.emit();
  }

}